import React, { Component } from "react";
import {
  Grid,
  Select,
  MenuItem,
  Button,
} from "@material-ui/core";
import style from "./style";
import moment from "moment";
import {primaryColor, webFont} from "../../config/theme";

const hours = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export default class TimeSlot extends Component {

  constructor(props) {
    super(props);

    const days =
      props.selectedDays &&
      props.selectedDays.length &&
      props.selectedDays
        .filter(day => {
          return day.selected;
        })
        .map(d => {
          return d.value;
        });


    const tmpDays =
      props.selectedDays &&
      props.selectedDays.length &&
      props.selectedDays.map(d => {
        return { ...d, selected: false };
      });

    const fromTime = this.props.fromTime || "06:00";
    const fromHour = this.props.fromHour || parseInt(fromTime.split(":")[0]);
    const fromMinutes = this.props.fromMinutes || fromTime.split(":")[1];

    const toTime = this.props.toTime || "06:00";
    const toHour = this.props.toHour || parseInt(toTime.split(":")[0]);
    const toMinutes = this.props.toMinutes || toTime.split(":")[1];

    this.state = {
      fromTime,
      from: this.props.from || "AM",
      to: this.props.to || "PM",
      toTime: this.props.toTime || "06:00",
      days: days || [],
      daysToSelect: props.selectedDays || [],
      tmpDays,
      validTime: true,
      fromHour,
      fromMinutes,
      toHour,
      toMinutes,
    };

  }

  timeValidate = () => {
    let format = 'HH:mm';
    let startTime = moment(this.state.fromTime+' ' +this.state.from, ["h:mm A"],format);
    let endtime = moment(this.state.toTime+' ' +this.state.to, ["h:mm A"],format);
    let validTime = (endtime.isAfter(startTime) && startTime.isBefore(endtime));
    this.setState({ validTime });
   };

  handelSelectFrom = value => {
    this.setState({ from: value },() => {
        this.timeValidate()
    });
  };

  onCreate = data => {
    const { validTime } =this.state;
    if(validTime) {
      this.props.onCreate(data);
    }
  };

  onFromTimeChange = (value) => {
    this.setState({ fromTime: value, startTime: moment(`${value} ${this.state.from}`, 'hh:mm A') },() => {
        this.timeValidate();
      });
  };

  onToTimeChange = (value) => {
    this.setState({ toTime: value, endTime: moment(`${value} ${this.state.to}`, 'hh:mm A') },() => {
        this.timeValidate();
    });
  };

  handelSelectTo = value => {
    this.setState({ to: value, endTime: moment(`${value} ${this.state.to}`, 'hh:mm A') },() => {
        this.timeValidate();
    });
  };

  selectDay = index => {
    let days = this.state.daysToSelect;
    const { days: selectedDays, tmpDays } = this.state;

    if (selectedDays.indexOf(days[index].value) < 0 && !days[index].selected) {
      selectedDays.push(days[index].value);
    } else {
      if (selectedDays.indexOf(days[index].value) > -1) {
        selectedDays.splice(selectedDays.indexOf(days[index].value), 1);
      }
    }

    days[index].selected = !days[index].selected;
    tmpDays[index].selected = !tmpDays[index].selected;
    this.setState({ daysToSelect: days, days: selectedDays, tmpDays });
  };

  render() {
    let data = {
      days: this.state.daysToSelect,
      fromTime: this.state.fromTime,
      from: this.state.from,
      toTime: this.state.toTime,
      to: this.state.to,
      selectedDays: this.state.days,
      fromHour: this.state.fromHour,
      fromMinutes: this.state.fromMinutes,
      toHour: this.state.toHour,
      toMinutes: this.state.toMinutes,
    };
    let validTime = this.state.validTime;

    return (
      <div style={style.container} className="slot-container">
        <Grid container>
          <Grid item md={12} sm={12} xs={12}>
            <p style={{...style.headerText}}>{this.props.title || "Time Slot"}</p>
          </Grid>
          <Grid item md={12} sm={12} xs={12}>
            <p style={style.labelText}>FROM</p>
          </Grid>
          <Grid item md={12} sm={12} xs={8} style={{display: 'flex'}}>
            {/*<TextField
              data-test-id={"fromtime"}
              className="time-input"
              type="time"
              style={style.inputText}
              inputProps={{
                min: "01:00",
                max: "12:00"
              }}
              defaultValue={this.props.fromTime || this.state.fromTime}
              onChange={evt => this.onFromTimeChange(evt.target.value)}
            />*/}
            <Select
              inputProps={{MenuProps: {disableScrollLock: true}}}
              className="select-option"
              data-test-id={"fromhour-id"}
              value={this.state.fromHour}
              onChange={evt => this.setState({
                fromHour: evt.target.value,
                fromTime: `${evt.target.value}:${this.state.fromMinutes}`,
                startTime: moment(`${evt.target.value}:${this.state.fromMinutes} ${this.state.from}`, 'HH:mm')
              }, () => {this.timeValidate();})}
              style={style.inputText}
            >
              {
                hours.map(hour => (
                  <MenuItem value={hour} key={hour} style={style.inputText}>
                    {hour < 10 ? `0${hour}` : hour}
                  </MenuItem>
                ))
              }
            </Select>
            <Select
              inputProps={{MenuProps: {disableScrollLock: true}}}
              className="select-option"
              data-test-id={"fromminute-id"}
              value={this.state.fromMinutes}
              onChange={evt => {
                this.setState({ fromMinutes: evt.target.value, fromTime: `${this.state.fromHour}:${evt.target.value}` });
                this.handelSelectFrom(this.state.from);
              }}
              style={{marginLeft:'24px', ...style.inputText}}
            >
              <MenuItem value={"00"} style={style.inputText}>
                00
              </MenuItem>
              <MenuItem value={"15"} style={style.inputText}>
                15
              </MenuItem>
              <MenuItem value={"30"} style={style.inputText}>
                30
              </MenuItem>
              <MenuItem value={"45"} style={style.inputText}>
                45
              </MenuItem>
            </Select>
            <Select
              inputProps={{MenuProps: {disableScrollLock: true}}}
              className="select-option"
              data-test-id={"frommenu-id"}
              value={this.state.from}
              onChange={evt => this.handelSelectFrom(evt.target.value)}
              style={{marginLeft:'24px'}}
            >
              <MenuItem value={"AM"} style={style.inputText}>
                AM
              </MenuItem>
              <MenuItem value={"PM"} style={style.inputText}>
                PM
              </MenuItem>
            </Select>
          </Grid>

          <Grid item md={12} sm={12} xs={12} style={{marginTop:24}}>
            <p style={style.labelText}>TO</p>
          </Grid>
          <Grid item md={12} sm={12} xs={8} style={{display: 'flex'}}>
            {/*<TextField
              className="time-input"
              data-test-id={"totime"}
              type="time"
              style={style.inputText}
              inputProps={{
                min: "01:00",
                max: "12:00"
              }}
              defaultValue={this.props.toTime || this.state.toTime}
              onChange={evt => this.onToTimeChange(evt.target.value )}
            />*/}
            <Select
              inputProps={{MenuProps: {disableScrollLock: true}}}
              className="select-option"
              data-test-id={"tohour-id"}
              value={this.state.toHour}
              onChange={evt =>
                this.setState({
                  toHour: evt.target.value,
                  toTime: `${evt.target.value}:${this.state.toMinutes}`,
                  endTime: moment(`${evt.target.value}:${this.state.toMinutes} ${this.state.to}`, 'hh:mm A')
                }, () => {
                  this.timeValidate();
                })
              }
              style={style.inputText}
            >
              {
                hours.map(hour => (
                  <MenuItem value={hour} key={hour} style={style.inputText}>
                    {hour < 10 ? `0${hour}` : hour}
                  </MenuItem>
                ))
              }
            </Select>
            <Select
              inputProps={{MenuProps: {disableScrollLock: true}}}
              className="select-option"
              data-test-id={"tominute-id"}
              value={this.state.toMinutes}
              onChange={evt => {
                this.setState({ toMinutes: evt.target.value, toTime: `${this.state.toHour}:${evt.target.value}` });
                this.handelSelectTo(this.state.to);
              }}
              style={{marginLeft:'24px', ...style.inputText}}
            >
              <MenuItem value={"00"} style={style.inputText}>
                00
              </MenuItem>
              <MenuItem value={"15"} style={style.inputText}>
                15
              </MenuItem>
              <MenuItem value={"30"} style={style.inputText}>
                30
              </MenuItem>
              <MenuItem value={"45"} style={style.inputText}>
                45
              </MenuItem>
            </Select>
            <Select
              inputProps={{MenuProps: {disableScrollLock: true}}}
              className="select-option"
              data-test-id={"tomenu-id"}
              value={this.state.to}
              onChange={evt => this.handelSelectTo(evt.target.value)}
              style={{marginLeft:'24px'}}
            >
              <MenuItem value={"AM"} style={style.inputText}>
                AM
              </MenuItem>
              <MenuItem value={"PM"} style={style.inputText}>
                PM
              </MenuItem>
            </Select>
          </Grid>

          {!!this.props.selectedDays && !!this.props.selectedDays.length && (
            <Grid item md={12} sm={12} xs={12} style={{marginTop: 30, textAlign: 'center'}}>

            </Grid>
          )}
          {!!this.props.selectedDays && !!this.props.selectedDays.length && (
            <Grid item md={12} sm={12} xs={12} >
              <Grid container style={{flexDirection: 'column'}}>
                <div className="day-heading">
                  <p>REPEATS</p>
                </div>
                <div className="day-column">
                  {this.state.daysToSelect.map((day, i) => (
                    <Button
                      data-test-id={"slotday-id"}
                      size="small"
                      onClick={() => this.selectDay(i)}
                      variant={
                        this.state.tmpDays[i].selected ? "contained" : "outlined"
                      }
                      color="primary"
                      key={i + day.value}
                      style={
                        this.state.tmpDays[i].selected
                          ? style.daySelected
                          : style.day
                      }
                    >
                      {day.name}
                    </Button>
                  ))}
                </div>
              </Grid>
            </Grid>
          )}
          {!!this.props.showDays && (
          <Grid item md={12} sm={12} xs={12} style={{
            marginTop: 30
          }}>

            <Grid container style={{marginTop: 10, justifyContent: 'space-between'}}>
              {this.props.daysToSelect.map(day => (
              <Button
                data-test-id={"repeatsday-id"}
                key={day.value}
                variant={
                  this.props.haveSlots(day) ? "contained" : "outlined"
                }
                color={"primary"}
                style={{
                  margin: 5,
                  width: 37,
                  minWidth: 37,
                  height: 37,
                  borderRadius: '50%',
                  fontFamily: webFont,
                  color: this.props.haveSlots(day) ? "white" : primaryColor,
                  boxShadow: 'none',
                }}
                onClick={() => this.props.onChooseButton(day)}
              >
                {day.name}
              </Button>))}
            </Grid>
          </Grid>)}
           <Grid item md={12} sm={12} xs={12}>
             <p style={{fontSize: 14, color: "red", fontFamily: webFont}}>{!validTime ? 'Invalid Time Slot':''}</p>
          </Grid>
          <Grid item md={12} sm={12} xs={12} style={{marginBottom:10, textAlign: 'center'}}>
            <Button
              data-test-id={"create-id"}
              variant={"contained"}
              color={"primary"}
              fullWidth
              style={style.createButton}
              onClick={() => this.onCreate(data)}
            >
              <p style={style.createButtonText}>{this.props.isUpdate ? 'Update' :  'Create' }</p>
            </Button>
          </Grid>
          <Grid item md={12} sm={12} xs={12} style={{marginBottom:10, textAlign: 'center'}}>
            <Button
            data-test-id={"cancel-id"}
              variant={"text"}
              color={"primary"}
              fullWidth
              style={style.cancelButton}
              onClick={this.props.onCancel}
            >
              <p style={style.cancelButtonText}> Cancel</p>
            </Button>
          </Grid>
        </Grid>
      </div>
    );
  }
}
